import axios from "axios";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { useState } from "react";
import "../CSS/spare.css";

const SpareProductListScreen = () => {
  let bikeData = [
    {
      name: "Lil E",
      id: "2589e79c-d310-4c76-80c4-5f12afebe259",
    },
    {
      name: "X1",
      id: "4b830ba9-b60e-4384-82ab-6bc68c5fc1ad",
    },
    {
      name: "X2",
      id: "35f2bf96-eed1-4189-a490-fe26318f307f",
    },
    {
      name: "X3",
      id: "0afaf40a-45b8-4cf1-bbac-de777bd5a030",
    },
    {
      name: "T-Rex+ V3",
      id: "e23ce720-b5aa-41ba-a966-9bb2f1f6fc3d",
    },
    {
      name: "T-Rex Air",
      id: "18f3278e-cdf5-4397-909e-5a4521ab64a8",
    },
    {
      name: "Legend 07 MSD Edition",
      id: "50d6e9e7-b74f-4452-b788-f9fb7b1a7592",
    },
    {
      name: "T-Rex Pro",
      id: "929c8c6a-c456-4e12-b26c-f5f73cd9becd",
    },
    {
      name: "ST-X",
      id: "626ecf86-6197-41ce-957e-0167cbe703e4",
    },
    {
      name: "Doodle Pro",
      id: "fd81ccdc-4089-456a-9f94-2343e1c474ce",
    },
    {
      name: "G1 Cargo E-Cycle",
      id: "ee74fa27-ec59-4b18-bf9c-c9a490637a05",
    },
    {
      name: "Ranger",
      id: "5f01ca41-e602-4637-acfd-3449a72b89a7",
    },
    {
      name: "Doodle V3",
      id: "fa81a9c7-556a-441e-85eb-7dd51228cfda",
    },
    {
      name: "EMX",
      id: "4bbc6488-8e8d-42f4-a374-9cfdecab8662",
    },
    {
      name: "EMX+",
      id: "53dd105f-622a-4206-ab09-707565bd79ad",
    },
    {
      name: "Neo",
      id: "5ca5bdff-9656-496a-b035-7ae124aad171",
    },
    {
      name: "X1 Limited Edition",
      id: "c2c9f7fc-4884-40f2-8f00-77f83794eb4a",
    },
  ];
  let { name } = useParams();
  const [spareData, setSpareData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const bike = bikeData.find((bike) => bike.name === name);
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            product_group_id: bike.id,
          },
        };
        const { data } = await axios.get(
          `https://www.emotorad.com/api/oms/spare`,
          config
        );
        setSpareData(data.data);
      } catch (error) {
        console.error("❌ Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <Navbar />
      {spareData && (
        <div className="container px-0 py-5">
          <h1
            className="store-heading mb-4"
            style={{ fontFamily: "Metropolis-bolder" }}
          >
            <b>Compatible Spare Parts</b>
          </h1>
          {spareData.length ? (
            <div className="table-wrapper">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>Item Name</th>
                    <th>MRP</th>
                  </tr>
                </thead>
                <tbody>
                  {spareData
                    .filter((item) => item.ecom_price)
                    .map((item, index) => (
                      <tr key={index}>
                        <td>{item.compatible_item_name}</td>
                        <td>₹{item.ecom_price}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          ) : (
            <>
              <p className="text-danger fw-bold">Not Found</p>
            </>
          )}
        </div>
      )}
      <Footer />
    </div>
  );
};

export default SpareProductListScreen;
